/**
 * Mega Menu animations.
 * @dependencies GSAP
 * @dependencies splitting.js
 */

import { TimelineLite, Power2, Power3 } from 'gsap'
import Splitting from "splitting";
const megaMenus = [];

// Mega Menu Class
class megaMenu {

  constructor(el) {
    this.el = el
    this.DOM = {
      link: this.el.querySelector('a'),
      menu: this.el.querySelector('a + ul'),
      bg: this.el.querySelector('.js-mega-menu-bg'),
      overlay: this.el.querySelector('.js-mega-menu-overlay'),
      deco: this.el.querySelector('.js-mega-menu-deco'),
      cols: this.el.querySelectorAll('.js-mega-menu-column'),
    }
    this.opened = false

    this.tl = new TimelineLite({ paused: true})
    this.init()
  }

  init () {
    this.DOM.link.addEventListener('click', (e) => this.toggleMenu(e));
    this.DOM.overlay.addEventListener('click', (e) => this.toggleMenu(e));
    const chars = Splitting({ target: this.DOM.deco })

    this.tl
      .to(this.DOM.bg, 0.6, { scaleY: 1, ease: Power2.easeInOut })
      .to(this.DOM.overlay, 0.7, { autoAlpha: 1 }, 0)
      .staggerFromTo(this.DOM.cols, 0.8, { y: 50, autoAlpha: 0, ease: Power3.easeOut }, { y: 0, autoAlpha: 1, ease: Power3.easeOut }, 0.05, 0.3)
      .set(this.DOM.deco, { autoAlpha: 1 }, 0.4)
      .staggerFromTo(chars[0].chars, 0.5, { y: -50, autoAlpha: 0, ease: Power3.easeOut }, { y: 0, autoAlpha: 1, ease: Power3.easeOut }, 0.05, 0.4)
  }

  animate (state) {
    state ? this.tl.timeScale(1).play() : this.tl.timeScale(1.9).reverse()
  }

  toggleMenu (e) {
    this.opened ? this.animationOut(e) : this.animationIn(e)
  }

  animationIn (e) {
    if (e) e.preventDefault()
    megaMenus.forEach((megaMenu) => {
      if (megaMenu.el != this.el) {
        megaMenu.animationOut(null)
      }
    })
    this.opened = true
    this.animate(this.opened)
  }

  animationOut (e) {
    if (e) e.preventDefault()
    this.opened = false
    this.animate(this.opened)
  }
}

// Init
const megaMenuItems = document.querySelectorAll('.header .has-children')
for (const item of megaMenuItems) {
  megaMenus.push(new megaMenu(item));
}
